<script>
export default {
  name: "DidoApidoc",
};
</script>

<script setup>
import { watch, computed, inject } from "vue";
import DidoApidocIntroduction from "./apidoc/Introduction.vue";
import DidoApidocDataOrganization from "./apidoc/DataOrganization.vue";
import DidoApidocUsage from "./apidoc/Usage.vue";
import DidoApidocExamples from "./apidoc/Examples.vue";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: false, default: "" },
});

// define events emitted
const emit = defineEmits(["bad-configuration"]);

// get apiUrl from props or inject if from parent
const apiUrl = computed(() => props.apiUrl || inject("apiUrl"));

// define computed data
const configured = computed(() => !!apiUrl.value);

// define watchers
watch(
  () => props.apiUrl,
  () => init(),
);

// define methods
const init = async () => {
  // if widget bad configured
  if (!configured.value) {
    emit("bad-configuration");
    return;
  }
};

// init
init();
</script>

<template>
  <div
    class="dido-widget-apidoc relative-position q-pa-md text-body2 text-justify"
  >
    <!-- Bad configuration of widget -->
    <div v-if="!configured">
      <div>Impossible de charger le composant...</div>
    </div>
    <template v-else>
      <!-- Introduction -->
      <QExpansionItem
        id="introduction"
        label="1 - Introduction"
        default-opened
        header-class="text-h5 bg-grey-2"
      >
        <DidoApidocIntroduction />
      </QExpansionItem>
      <!-- Data Organization -->
      <QExpansionItem
        id="data-organization"
        label="2 - Organisation des données"
        header-class="text-h5 bg-grey-2"
        class="q-mt-md"
      >
        <DidoApidocDataOrganization />
      </QExpansionItem>
      <!-- API Usage-->
      <QExpansionItem
        id="api-usage"
        label="3 - Utilisation de l'API"
        header-class="text-h5 bg-grey-2"
        class="q-mt-md"
      >
        <DidoApidocUsage :api-url="apiUrl" />
      </QExpansionItem>
      <!-- Examples -->
      <QExpansionItem
        id="api-usage-examples"
        label="4 - Exemples d'utilisation de l'API avec curl et jq"
        header-class="text-h5 bg-grey-2"
        class="q-mt-md"
      >
        <DidoApidocExamples :api-url="apiUrl" />
      </QExpansionItem>
    </template>
  </div>
</template>

<style lang="sass" scoped>
.dido-widget-apidoc
  .underline-dotted
    border-bottom: 1px dotted blue
  .text-body2
    line-height: 1.5rem
    text-align: justify
  ul li
    line-height: 1.5rem
  ul.data-structure-list li:not(:last-child)
    margin-bottom: 3px
  ul.resources-id-list li:not(:last-child)
    margin-bottom: 12px
  ul.error-code-list li:not(:last-child)
    margin-bottom: 3px
  ul.output-formats-list li:not(:last-child)
    margin-bottom: 3px
  ul.sort-clause-list li:not(:last-child)
    margin-bottom: 12px
</style>
